export const URL_REDIRECT_AFTER_SUCCESS = () => {
  let url = '/subscription/payment/';

  if (!window.olistmalt) {
    return url;
  }

  const journeyId = window.olistmalt.getJourneyId();

  url += `?journey_id=${journeyId}`;

  return url;
};
